import { useState } from 'react';
import PropTypes from 'prop-types';
import { InputControlled } from 'components/UI/InputControlled/InputControlled';
import { DropdownWithMenu } from 'components/UI/DropdownWithMenu/DropdownWithMenu';
import { ReactComponent as HelpIcon } from 'assets/icons/svgs/icon-help.svg';
import useWindowDimensions from 'hooks/use-window-dimensions';
import './RegistrationFormSections.scss';

export const ContactInformation = (props) => {
  const {
    Prefixes,
    DateOfBirth,
    setSelectedPrefix,
    setSelectedDobDay,
    setSelectedDobMonth,
    setSelectedDobYear,
  } = props;
  const [openPopup, setOpenPopup] = useState(false);
  const { isMobile } = useWindowDimensions();
  const popupHintClass = isMobile ? 'hint-visible-m' : 'hint-visible-d';

  const showPopupHandler = (inputId) => {
    if (!isMobile) {
      setOpenPopup(inputId);
    }
  };

  const showPopupMobileHandler = (inputId) => {
    setOpenPopup((prevState) => (prevState ? false : inputId));
  };

  const renderInputHintButton = (inputId) => (
    <button
      type="button"
      className="hint-btn visible-xs"
      onClick={() => showPopupMobileHandler(inputId)}
    >
      <HelpIcon className="registration-form__help-icon" />
    </button>
  );

  const prefixDropDownOptions = Prefixes.map((prefix) => ({
    key: prefix.Description,
    name: prefix.Description,
  }));

  const prefixDropdownUpdateHandler = (prefix) => {
    setSelectedPrefix(prefix);
  };

  const getDobDropDownOptions = (DobOptions) =>
    DobOptions.map((item) => ({
      key: item,
      name: item,
    }));

  const dobDayDropdownUpdateHandler = (day) => {
    setSelectedDobDay(day);
  };

  const dobMonthDropdownUpdateHandler = (month) => {
    setSelectedDobMonth(month);
  };

  const dobYearDropdownUpdateHandler = (year) => {
    setSelectedDobYear(year);
  };

  return (
    <div className="form-section">
      <h2 className="h4">Contact information</h2>

      <div className="form-subsection">
        <div className="form-group">
          <DropdownWithMenu
            singleColumn
            hideDefaultItem
            dropdownChangeHandler={prefixDropdownUpdateHandler}
            defaultChosenValue="Title (optional)"
            menuData={prefixDropDownOptions}
          />
        </div>

        <div className="form-group">
          <InputControlled type="text" id="regFirstName" labelText="First name" />
        </div>

        <div className="form-group">
          <InputControlled type="text" id="regLastName" labelText="Last name" />
        </div>
      </div>

      <div className="form-subsection">
        <label className="control-label static-label">Date of birth (optional)</label>
        <div className="row">
          <div className="col-xs-4">
            <DropdownWithMenu
              singleColumn
              hideDefaultItem
              dropdownChangeHandler={dobDayDropdownUpdateHandler}
              defaultChosenValue="DD"
              menuData={getDobDropDownOptions(DateOfBirth.Days)}
            />
          </div>
          <div className="col-xs-4">
            <DropdownWithMenu
              singleColumn
              hideDefaultItem
              dropdownChangeHandler={dobMonthDropdownUpdateHandler}
              defaultChosenValue="MM"
              menuData={getDobDropDownOptions(DateOfBirth.Months)}
            />
          </div>

          <div className="col-xs-4">
            <DropdownWithMenu
              singleColumn
              hideDefaultItem
              dropdownChangeHandler={dobYearDropdownUpdateHandler}
              defaultChosenValue="YYYY"
              menuData={getDobDropDownOptions(DateOfBirth.Years)}
            />
          </div>
        </div>
      </div>

      <div className="form-subsection">
        <label className="control-label static-label">Contact number</label>

        <div className="form-group has-hint">
          <InputControlled
            type="text"
            id="regPhoneNumber"
            labelText="Phone Number"
            showPopupHandler={showPopupHandler}
          />
          {renderInputHintButton('regPhoneNumber')}

          <div className={`form-hint ${openPopup === 'regPhoneNumber' ? popupHintClass : ''}`}>
            <p>
              Please enter at least either your phone number <strong>or</strong> mobile number so we
              can contact you in the event of a change in performance.
            </p>
            <p>
              - Phone Number: <strong>9xxxxxxx</strong>
            </p>
          </div>
        </div>

        <div className="form-group has-hint">
          <InputControlled
            type="text"
            id="regMobileNumber"
            labelText="Mobile Number"
            showPopupHandler={showPopupHandler}
          />

          {renderInputHintButton('regMobileNumber')}

          <div className={`form-hint ${openPopup === 'regMobileNumber' ? popupHintClass : ''}`}>
            <p>
              Please enter at least either your phone number <strong>or</strong> mobile number so we
              can contact you in the event of a change in performance.
            </p>
            <p>
              - Mobile Number: <strong>04xxxxxxxx</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

ContactInformation.propTypes = {
  Prefixes: PropTypes.array,
  DateOfBirth: PropTypes.object,
  setSelectedPrefix: PropTypes.func,
  setSelectedDobDay: PropTypes.func,
  setSelectedDobMonth: PropTypes.func,
  setSelectedDobYear: PropTypes.func,
};
